// extracted by mini-css-extract-plugin
export default {"approveButton":"ApproveButton_approveButton__vequU","buttonContainer":"ApproveButton_buttonContainer__IUV51"};